import { render, staticRenderFns } from "./Transactionality.vue?vue&type=template&id=1ae430be&"
import script from "./Transactionality.vue?vue&type=script&lang=js&"
export * from "./Transactionality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae430be')) {
      api.createRecord('1ae430be', component.options)
    } else {
      api.reload('1ae430be', component.options)
    }
    module.hot.accept("./Transactionality.vue?vue&type=template&id=1ae430be&", function () {
      api.rerender('1ae430be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/vistas/transactionality/Transactionality.vue"
export default component.exports